import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import Header from "../components/Header"
import TestsHero from "../components/local/MentalTests/Hero"
import FAQs from "../components/local/MentalTests/FAQs"
import Blog from "../components/local/Blog/Blog"
import CTA from "../components/local/MentalTests/CTA"
import Footer from "../components/local/Footer"
import styles from "./index.module.scss"
import { getBlogPosts, getBlogPost } from "../utils/blog"
import { goToStressTestPSS } from "../utils/browser"

export async function getStaticProps({ locale, locales }) {
  const { posts, postsUnordered } = await getBlogPosts({
    locale,
    params: "?tags=33",
  })

  const language = locale.split("-")[0] || "en"

  const postIds = {
    en: 177,
    de: 179,
    es: 181,
    fr: 183,
    it: 185,
    pt: 187,
  }

  const postId = postIds[language] || 177

  const { content: { rendered: post = "" } = {} } = await getBlogPost({
    postId,
  })

  return {
    props: {
      ...(await serverSideTranslations(locale.substring(0, 2), [
        "tests",
        "common",
      ])),
      post,
      posts,
      locales,
      postsUnordered,
    },
  }
}

function ADHDTestPage({ locales, post, ...props }) {
  const { t } = useTranslation("tests")

  const buttonProps = {
    buttonText: t("TEST_ADHD_ASRSV1_BUTTON", { ns: "tests" }),
    buttonAction: goToStressTestPSS,
  }

  return (
    <div className={styles.MainWrapper}>
      <Header
        logoUrl="/assets/logo-black.png"
        pageTitle={t("TEST_ADHD_ASRSV1_TITLE")}
        pageDescription={t("TEST_ADHD_ASRSV1_META")}
        fixedHeader={false}
        transparent={true}
        displayProductHunt={true}
      />
      <TestsHero
        h1Description={t("TEST_ADHD_ASRSV1_H1_DESCRIPTION")}
        h1Content={t("TEST_ADHD_ASRSV1_H1")}
        subTitle={t("TEST_ADHD_ASRSV1_SUBTITLE")}
        imageAlt={t("TEST_ADHD_ASRSV1_TITLE")}
        imageUrl="adhd-testing-free"
        {...buttonProps}
      />
      <FAQs post={post} />
      <CTA {...buttonProps} />
      <Blog posts={props.posts} />

      <Footer />
    </div>
  )
}

export default ADHDTestPage
